import { VolumeUpIcon } from "@heroicons/react/outline";

export function ActiveSpeaker(props) {
  const name = props.name;

  return (
    <>
      {name ? (
        <div className="absolute inset-1/2 top-10 h-8 w-32 rounded-full bg-gray-500 text-sm text-white shadow-md">
          <div className="flex h-full w-full items-center justify-center space-x-2 px-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              aria-hidden="true"
              className="h-4 w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
              ></path>
            </svg>

            <div className="mb-1">{name}</div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
